<template>
  <div class="width-100" :class="{ error: errorMessage, success: meta.valid }">
    <div class="p-inputgroup">
      <MultiSelect
        :id="name"
        v-model="inputValue"
        :name="name"
        :options="items"
        :option-label="optionLabel"
        :option-value="optionValue"
        :option-group-label="optionGroupLabel"
        :option-group-children="optionGroupChildren"
        :model-value="modelValue"
        :class="className"
        :filter="filter"
        :disabled="disabled"
        :names="names"
        class="width-72"
        @input="handleChange"
        @change="checkChange"
      >
        <template #value="slotProps">
          <div
            v-if="slotProps.value"
            class="country-item country-item-value flex"
          >
            <Icon type="favicon" :icon="'Calendar'" class="Icon" />

            <div class="pl-1">
              {{
                slotProps.value == null || slotProps.value == 0
                  ? 0
                  : slotProps.value.length
              }}
              Calendars
            </div>
          </div>
        </template>
        <template #option="slotProps">
          <div class="country-item">
            <div
              class="color-box"
              :style="{ background: `#` + slotProps.option.color }"
            />

            <div>{{ slotProps.option.display_name }}</div>
          </div>
        </template>
        <template #optiongroup="slotProps">
          <div class="flex country-item">
            <div class="width-100 calendar-template-header">
              <span> {{ names[slotProps.index] }}</span>
            </div>
          </div>
        </template>
      </MultiSelect>

      <!-- {{ inputValue }}--{{ modelValue }} -->
    </div>
    <small v-show="errorMessage" class="p-error block mt-1">
      {{ errorMessage }}
    </small>
  </div>
</template>
<script>
import { useField } from "vee-validate";
import { watch } from "vue";
import { getMyGemService } from "@/services";
import { mapActions } from "vuex";

export default {
  inject: ["service", "meta", "windowIndex"],
  props: {
    options: {
      type: [String, Array],
      default: "",
    },
    names: {
      type: [String, Array],
      default: "",
    },
    optionLabel: {
      type: String,
      default: "",
    },
    optionValue: {
      type: String,
      default: "",
    },
    optionGroupLabel: {
      type: String,
      default: "",
    },
    optionGroupChildren: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    emptyFilterMessage: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    filter: {
      type: Boolean,
      required: "",
    },
    showClear: {
      type: Boolean,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: Boolean,
      default: true,
    },
    addon: {
      type: Boolean,
      default: true,
    },
    serviceId: {
      type: Number,
    },
    btnCreate: {
      type: Boolean,
      default: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedValue: null,
      items: [],
      servicebyDomian: null,
      loading: false,
      calendars: [],
    };
  },
  computed: {
    color() {
      var color = "";
      this.calendars.forEach((element) => {
        if (element.id == this.inputValue) {
          color = element.color;
        }
      });

      return color;
    },
    CalendarName() {
      var name = "";
      this.calendars.forEach((element) => {
        if (element.id == this.inputValue) {
          name = element.display_name;
        }
      });

      return name;
    },
  },
  mounted() {
    this.fetchData();
  },
  created() {
    this.servicebyDomian = getMyGemService(this.serviceId);
  },
  methods: {
    ...mapActions("fetch", ["fetch", "refresh"]),
    fetchData() {
      this.servicebyDomian.get().then((response) => {
        this.items = response;
        this.names.forEach((element, index) => {
          this.items[index].items.forEach((element2) => {
            this.calendars.push(element2);
          });
        });
      });
    },
  },
  setup(props, { emit }) {
    const {
      value: inputValue,
      errorMessage,
      handleChange,
      meta,
      resetField,
    } = useField(props.name, undefined, {
      initialValue: props.modelValue,
    });

    resetField({
      value: props.modelValue,
    });

    watch(
      () => props.modelValue,
      (first) => {
        inputValue.value = first;
      }
    );
    function checkChange(event) {
      //  event.preventDefault();
      inputValue.value = event.value;
      resetField({
        value: event.value,
      });
      emit("update:modelValue", event.value);

      emit("changeSSR", event);
    }
    function onBtnClick() {
      emit("btn-clicked", { id: inputValue.value });
    }

    return {
      handleChange,
      errorMessage,
      inputValue,
      meta,
      checkChange,
      onBtnClick,
      alert,
    };
  },
};
</script>

<style scoped>
div.error .dropdown {
  background-color: var(--error-bg-color);
  color: var(--error-color);
}

div.error input:focus {
  border-color: var(--error-color);
}

.Dropdown.success input {
  background-color: var(--success-bg-color);
  color: var(--success-color);
}

.Dropdown.success input:focus {
  border-color: var(--success-color);
}

.p-inputgroup {
  display: flex;
  align-items: stretch;
}
.width-72 {
  width: 72% !important;
}
</style>
